"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGameBridge_1 = require("./useGameBridge");
function useLocalize(key) {
    const gameBridge = (0, useGameBridge_1.default)();
    const [data, setData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        gameBridge.localize(key).then(setData);
    }, [gameBridge, key]);
    return data;
}
exports.default = useLocalize;
